import React from "react";

import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import TableCalls from "./table-calls";
import Call from "./call";
import Applications from "../applications/table-applications"
import Application from "../applications/application";

import "../../../../../styles/css/App.css";

function Calls({ history }) {
  
  let { path, url } = useRouteMatch();

  const open = (event, rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TableCalls
            {...{
              open
            }}
          />
        </Route>
        <Route exact path={`${path}/:callId`}
          render={(props) => <Call callId={props.match.params.callId}/>}
        />
        <Route exact path={`${path}/:callId/applications`}
          render={(props) => <Applications callId={props.match.params.callId}/>}
        />
        <Route exact path={`${path}/:callId/applications/:applicationId`}
          render={(props) => <Application applicationId={props.match.params.applicationId}/>}
        />
      </Switch>
    </div>
  );

}

export default withRouter(Calls);
